import React from "react";
import ApartmentsReportView from "../../../../views/dashboard/reports/apartments";

const ApartmentsReport = () => {
  return <ApartmentsReportView />;
};

export default ApartmentsReport;
